import { SubmitButton } from 'components/common/buttons/SubmitButton';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Select, selectCustomStyles } from './Select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchVendors } from 'slices/vendorSlice';
import { CheckinCheckout } from 'components/ScheduleForm';
import { CheckinDateTimeInputs } from 'components/ScheduleForm';
import { CheckoutDateTimeInputs } from 'components/ScheduleForm';
import { CommentsAndNotes } from 'components/ScheduleForm';
import { fetchTranslators } from 'slices/inviteTranslatorSlice';
import { inviteTranslatorsSelector } from 'slices/inviteTranslatorSlice';
import { MultiSelect } from './MultiSelect';
import CustomMultiSelect from './CustomMultiSelect';

function SelectTranslatorModal({
    isOpen,
    onClose,
    onConfirm,
    item,
    modalTitle,
}) {

    const dispatch = useDispatch();
    const methods = useForm({
        defaultValues: {
            interpreter_id: null,
            freelancer_id: null,
        }
    });
    const { inviteTranslators, last_page: totalPages, loader, allTranslators } = useSelector(inviteTranslatorsSelector);
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, clearErrors, } = methods

    // Permanent staff and freelancers get separate, mutually exclusive selects
    const filteredInterpreters = React.useMemo(() => {
        return allTranslators
            ?.filter(item => item?.employment_type !== 'freelancer')
            .map(item => ({
                label: item?.user?.name,
                value: item?.id,
            })) || [];
    }, [allTranslators]);

    const filteredFreelancers = React.useMemo(() => {
        return allTranslators
            ?.filter(item => item?.employment_type === 'freelancer')
            .map(item => ({
                label: item?.user?.name,
                value: item?.id,
            })) || [];
    }, [allTranslators]);

    useEffect(() => {
        if (isOpen) {
            // fresh selections each time the modal opens
            setValue('interpreter_id', null);
            setValue('freelancer_id', null);
            dispatch(fetchTranslators(item?.id, { employment_type: 'all' }));
        }
    }, [isOpen])

    // useEffect(() => {
    //     setValue("interpreter_id", item?.appointment_assign?.interpreter_id || "");
    // }, [item, isOpen])



    const isInterpreter = useMemo(() => {
        return watch('interpreter_id') ? true : false
    }, [watch('interpreter_id'), isOpen])

    const isFreelancer = useMemo(() => {
        return watch('freelancer_id') ? true : false
    }, [watch('freelancer_id'), isOpen])


    // #region Interpreter Dropdown 
    // const [ed, setFilterInterpreters] = useState({
    //     label: "",
    //     value: ""
    // })

    // useEffect(() => {
    //     if (allTranslators?.user?.name && allTranslators?.id) {
    //         setFilterInterpreters({
    //             label: allTranslators?.user?.name || "",
    //             value: allTranslators?.id || ""
    //         })
    //     } else {
    //         setFilterInterpreters(null)
    //     }
    // }, [allTranslators])




    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <FormProvider {...methods}>
                    <form action="" onSubmit={handleSubmit((data) => onConfirm(data?.interpreter_id || data?.freelancer_id))}>
                        <ModalHeader className='header_modal align-items-center'>
                            <h5 className="modal-title_u">{modalTitle || "Assign"}</h5>
                        </ModalHeader>
                        <ModalBody className='modal_form_body'>
                            <div
                             style={{ backgroundColor: "#F2F2F2", padding: "20px", borderRadius: "14px", height: "auto"}}
                            className=' step_1'>
                                {/* TRANSLATOR SELECT (permanent staff) */}
                                <div
                                className="row-primary">
                                    <h2>Translator</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="interpreter_id"
                                            control={control}
                                            render={({ field }) =>
                                                <div style={{ width: "100%" }}>
                                                    <Select
                                                        menuPlacement='auto'
                                                        styles={{ ...selectCustomStyles }}
                                                        isDisabled={isFreelancer}
                                                        value={filteredInterpreters.find(f => f.value == field.value) || null}
                                                        options={filteredInterpreters}
                                                        isClearable
                                                        onChange={(value) => {
                                                            // the shared Select wrapper already unwraps option.value
                                                            field.onChange(value ?? null);
                                                        }}
                                                    />
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>

                                {/* FREELANCER SELECT (freelance interpreters) */}
                                <div
                                className="row-primary">
                                    <h2>Freelancer</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="freelancer_id"
                                            control={control}
                                            render={({ field }) =>
                                                <div style={{ width: "100%" }}>
                                                    <Select
                                                        menuPlacement='auto'
                                                        styles={{ ...selectCustomStyles }}
                                                        isDisabled={isInterpreter}
                                                        value={filteredFreelancers.find(f => f.value == field.value) || null}
                                                        options={filteredFreelancers}
                                                        isClearable
                                                        onChange={(value) => {
                                                            // the shared Select wrapper already unwraps option.value
                                                            field.onChange(value ?? null);
                                                        }}
                                                    />
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>

                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <SubmitButton btnText="Submit" />
                            <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                        </ModalFooter>
                    </form>
                </FormProvider>
            </Modal>
        </>
    );
}

export default SelectTranslatorModal;